<template>
  <div class="tw-space-y-4">
    <div class="tw-flex tw-flex-wrap tw-items-baseline tw-justify-between tw-gap-3">
      <h2 class="tw-text-lg tw-font-semibold tw-tracking-tight tw-text-slate-900">Load {{ load.loadDocumentId }}</h2>
      <div class="tw-text-sm tw-text-slate-600">Status: {{ load.status }}</div>
    </div>

    <div class="tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4 tw-text-sm tw-text-slate-700">
      <div>Created: {{ formatDatetime(load.createdAt) }}</div>
      <div>Last updated: {{ (load.lastUpdatedAt && formatDatetime(load.lastUpdatedAt)) || '---' }}</div>
    </div>

    <div class="tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white tw-p-4">
      <GmapMap
        v-if="!!load.gpsPath"
        :center="load.gpsPath.path[0]"
        :zoom="6"
        map-type-id="terrain"
        class="map-responsive"
      >
        <GmapPolyline :path="load.gpsPath.path"> </GmapPolyline>

        <GmapMarker
          v-for="(point, pointIdx) in load.gpsPath.path"
          :key="pointIdx"
          :position="point"
          :clickable="true"
          :draggable="true"
        />
      </GmapMap>
      <p v-else class="tw-text-sm tw-text-slate-600">
        (no GPS trip data for this load yet)
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
// import AddNotesArea from '@/components/core/AddNotesArea.vue';
import UpdateCustomerName from '@/gql/customers/UpdateCustomerName.gql';
// import DropdownList from '../core/DropdownList.vue';
import { datetimeFormatMixin } from '../../utils/date';

export default defineComponent({
  name: 'LoadDetailModal',

  props: {
    load: Object,
  },
  mixins: [datetimeFormatMixin],
  data() {
    return {
      isEditingCustomer: false,
      customerQuery: null,
    };
  },
  components: {
    // AddNotesArea,
    // DropdownList,
  },
  mounted() {
    // this.customer = this.container.customer;
  },
  computed: {
  },

  methods: {
    autoCompleteCustomer(val) {
      (this as any).customerQuery = val;
    },
    customerUrl(customer) {
      return `/customers/${customer.id}`;
    },
    onCustomerChange() {
      (this as any).customerDropdownOpen = true;
    },
    startCustomerEdit() {
      (this as any).isEditingCustomer = true;
    },
    updateCustomer() {
      const vm = (this as any);

      if (vm.container.customer !== '') {
        vm.$apollo
          .mutate({
            mutation: UpdateCustomerName,
            variables: {
              customerName: vm.customerQuery,
              containerNumber: vm.container.containerId,
            },
          })
          .then((data) => {
            vm.isEditingCustomer = false;
            vm.updateContainer();
            console.log(data);
          })
          .catch((error) => {
            vm.isEditingCustomer = false;
            console.error(error);
            vm.customerQuery = null;
          });
      }
    },
  },
});
</script>

<style lang="scss">
#load-content-body {
  flex-direction: column;
}

.map-responsive {
  padding-bottom:56.25%;
  position:relative;
  height:0;
  margin: auto; /* for centering */
}
</style>
